import firebase from "firebase/app";
import "firebase/firebase-messaging";

const config = {
  apiKey: "AIzaSyDVXJoVuprwSN4Pe_T49T7yW0Dn-wwZTxk",
  authDomain: "pbxberry-fab01.firebaseapp.com",
  projectId: "pbxberry-fab01",
  storageBucket: "pbxberry-fab01.appspot.com",
  messagingSenderId: "420494865514",
  appId: "1:420494865514:web:c0de075e34096bdfbec613",
  measurementId: "G-PXWET4NSP8",
};

firebase.initializeApp(config);

export default firebase.messaging();
